import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import { resolveImg, formatDate } from "@/lib/blog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BlogSection = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios.get(`${API}/blogs?limit=3`).then(({ data }) => setPosts(data)).catch(() => {});
  }, []);

  if (posts.length === 0) return null;

  return (
    <section id="journal" className="bg-konattu-cream py-24 md:py-32" data-testid="blog-section">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <Reveal><span className="font-mono text-xs tracking-[0.35em] text-konattu-red">/ THE JOURNAL</span></Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-display font-bold text-konattu-charcoal tracking-tight leading-[0.95] text-4xl md:text-6xl">
                News, offers<br />& insights.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <Link to="/blog" data-testid="blog-viewall" className="group inline-flex items-center gap-2 font-mono text-xs tracking-[0.25em] text-konattu-charcoal hover:text-konattu-red transition-colors">
              VIEW ALL POSTS <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
            </Link>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {posts.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.08}>
              <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${i}`} className="group block border border-konattu-charcoal/12 hover:border-konattu-red/60 transition-colors duration-300 h-full">
                <div className="aspect-[16/10] overflow-hidden bg-konattu-sand">
                  {p.cover_image ? (
                    <img src={resolveImg(p.cover_image)} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center bg-konattu-charcoal">
                      <span className="font-display font-bold text-4xl text-konattu-red">K</span>
                    </div>
                  )}
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-2 mb-3 font-mono text-[10px] tracking-[0.2em] text-konattu-charcoal/50">
                    {p.tags?.[0] && <span className="text-konattu-red">{p.tags[0].toUpperCase()}</span>}
                    <span>{formatDate(p.created_at)}</span>
                  </div>
                  <h3 className="font-display font-semibold text-xl text-konattu-charcoal tracking-tight leading-snug group-hover:text-konattu-red transition-colors">{p.title}</h3>
                  <p className="mt-2 font-body text-sm text-konattu-charcoal/65 leading-relaxed line-clamp-3">{p.excerpt}</p>
                  <span className="mt-4 inline-flex items-center gap-1 font-mono text-[11px] tracking-[0.2em] text-konattu-red">READ <ArrowUpRight size={12} /></span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
